<template>
  <div>
    <input
      type="text"
      v-model="tempName"
      :placeholder="placeholder"
      class="inputComponent__input"
      @input="updateInput()"
    />
  </div>
</template>

<script>
export default {
  name: 'SmallInput',
  props: {
    name: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    input_class_name: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      tempName: this.name,
    };
  },
  methods: {
    updateInput: function () {
      this.$emit('update:field', this.tempName);
    },
  },
};
</script>

<style scoped></style>
